// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Xamp","hide":"_3BQSg"};